const CHAR_DELAY = 60;
const ERASE_DELAY = 35;
const HOLD = 1800;
const PAUSE = 200;

function typeIn(wordEl, text, onDone) {
    let i = 0;
    wordEl.textContent = '';
    (function step() {
        if (i < text.length) {
            wordEl.textContent += text[i++];
            window.setTimeout(step, CHAR_DELAY);
        } else if (onDone) {
            onDone();
        }
    })();
}

function eraseOut(wordEl, onDone) {
    (function step() {
        const current = wordEl.textContent;
        if (current.length > 0) {
            wordEl.textContent = current.slice(0, -1);
            window.setTimeout(step, ERASE_DELAY);
        } else if (onDone) {
            onDone();
        }
    })();
}

function start(heading) {
    const wordEl = heading.querySelector('[data-blog-word]');
    if (!wordEl || heading.dataset.blogTypewriterInit === '1') {
        return;
    }
    heading.dataset.blogTypewriterInit = '1';

    let words = [];
    try {
        words = JSON.parse(heading.dataset.words || '[]');
    } catch (_) {
        words = [];
    }
    if (!words.length) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        wordEl.textContent = words[0];
        return;
    }

    let index = 0;
    function cycle() {
        const word = words[index];
        index = (index + 1) % words.length;
        typeIn(wordEl, word, () => {
            window.setTimeout(() => {
                eraseOut(wordEl, () => {
                    window.setTimeout(cycle, PAUSE);
                });
            }, HOLD);
        });
    }

    cycle();
}

export function initBlogTypewriter() {
    document.querySelectorAll('[data-blog-typewriter]').forEach(start);
}
